import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTwitterInsertPicIconProps extends SvgIconProps {}
/**
 * component used to display twitter insert pic icon in twitter interaction
 * @param props - CcfTwitterInsertPicIconProps
 * @example - <CcfTwitterInsertPicIcon />
 * @returns SVG of twitter insert pic icon in twitter interaction
 */
export function CcfTwitterInsertPicIcon(props: CcfTwitterInsertPicIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_insert_pic" clip-path="url(#clip-ic_insert_pic)">
        <path id="Path_13638" data-name="Path 13638" d="M23.59,21.636V7.954A1.954,1.954,0,0,0,21.636,6H7.954A1.954,1.954,0,0,0,6,7.954V21.636A1.954,1.954,0,0,0,7.954,23.59H21.636A1.954,1.954,0,0,0,23.59,21.636ZM11.375,16.261,13.818,19.2l3.42-4.4,4.4,5.863H7.954Z" transform="translate(-4.795 -4.795)"/>
      </g>
    </SvgIcon>
  );
}

export default CcfTwitterInsertPicIcon;
